import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import GlobalSearchModal from '../../modal/GlobalSearchModal';
import BottomPurchaseBar from '../util/BottomPurchaseBar';
import BottomTabBar from '../util/BottomTabBar';
import Header from '../util/Header';
import './StoreLayout.css';

const StoreLayout = () => {
  const location = useLocation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  // 상세 페이지 여부 판별
  const isDetail = /^\/store\/goods\/[0-9]+/.test(location.pathname);

  // 상세 페이지면 다른 props 적용
  const headerProps = isDetail
    ? { useLogo: false, left: 'back', title: '', rightIcon1: 'home', rightIcon2: 'cart', modalOpen: () => setIsModalOpen(true)}
    : { useLogo: true, left: '', title: '', rightIcon1: 'cart', rightIcon2: '', modalOpen: () => setIsModalOpen(true)};

  return (
    <>
      <div className="store-layout">
        <Header {...headerProps} />
        <Outlet />
        {isDetail ? <BottomPurchaseBar /> : <BottomTabBar />}

        {isModalOpen && (
          <>
          <div className="modal-wrapper">
            <GlobalSearchModal onClose={()=>setIsModalOpen(false)}/>
          </div>
          </>
        )}
      </div>
    </>
  );
};

export default StoreLayout;
